export const positions = ["MANAGER","PRESIDENT","GENERAL_DIRECTOR","FINANCIAL_DIRECTOR","COMMERCIAL_DIRECTOR","EXPORT_MANAGER","COMMUNICATION_DIRECTOR","ACCOUNTING_MANAGER","ACCOUNTANT","ACCOUNTING_ASSISTANT","ASSISTANT_DIRECTOR","COMMERCIAL","OWNER"];

// To be aligned with MAX_INDIVIDUAL_WORKERS_FOR_BILLING on backend.
export const maxIndividualOfWorkers = 12;

export const nbOfEmployees = ["10","50","100","500","more"];